export default __webpack_public_path__ + "static/media/solbrain06.602c1ddf.jpg";